import type React from 'react';
import SessionStatusIndicator from '../atoms/SessionStatusIndicator';
import SessionTitle from '../atoms/SessionTitle';

export interface SessionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  status?: 'active' | 'idle' | 'offline';
  actions?: React.ReactNode;
}

export default function SessionHeader({
  title,
  status = 'active',
  actions,
  className = '',
  ...props
}: SessionHeaderProps) {
  return (
    <div className={`flex items-start justify-between ${className}`} {...props}>
      <div className="flex-1 min-w-0 pr-2">
        <div className="flex items-center space-x-2">
          <SessionStatusIndicator status={status} size="md" />
          <SessionTitle size="md" truncate>
            {title}
          </SessionTitle>
        </div>
      </div>
      
      {actions && (
        <div className="flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
          {actions}
        </div>
      )}
    </div>
  );
}